import { JwtHelperService } from "@auth0/angular-jwt";
import { Injectable } from '@angular/core';
import { SharingDataService } from './sharing-data.service';
import { UserService } from '../workflow/user/user.service';
import { CommonService } from './common.service';
import { decode } from 'punycode';
import { ErrorHandlingService } from './errorHandling.service';
import { TranslateResourceDefinitionPipe } from '../shared/pipes/translateResourceDefinition.pipe';
import { timeout } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TranslateTextPipe } from '../shared/pipes/translateText.pipe';

declare const globalConfig: any;

@Injectable({
  providedIn: 'root'
})
export class AuthentService {

  constructor(
    private shareData: SharingDataService,
    private commonService: CommonService,
    private errorHandlingService: ErrorHandlingService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    private translateText: TranslateTextPipe,
    private router: Router,
  ) { }

  waitForRefreshToken :boolean;

  login(login, password, redirectUrl?: string) {
    var resourceDefinition;
    var gipDefault;
    this.shareData.currentResourceDefinition.subscribe(data => resourceDefinition = data);
    this.shareData.currentGipDefault.subscribe(data => gipDefault = data);
    let requestBody = new URLSearchParams();
    requestBody.set('username', login);
    requestBody.set('password', password);
    requestBody.set('grant_type', 'password');
    requestBody.set('scope', 'openid email profile offline_access');

    var url = globalConfig['AuthentificationConfig'];

    var authorization = globalConfig['Authorization'];

    const origin = window.location.origin;
    fetch(`${url}protocol/openid-connect/token`, {
      method: 'POST', body: requestBody, headers: {
        "Authorization": `Basic ${btoa(authorization)}`,
        "Content-Type": "application/x-www-form-urlencoded",
        "Host": url,
        "Origin" : origin,
      },
    })
      .then(response => {
        if(response.status > 403) this.errorHandlingService.showError(this.translateResourceDefinition.transform("PortalTechnicalFail", resourceDefinition, "KEY_NAME", "LONG_TEXT", "LOGIN"), undefined);
        response.json().then(result => {
          if(result.number == 1401){
            this.errorHandlingService.showInfo(this.translateResourceDefinition.transform("Incorrect", resourceDefinition, "KEY_NAME", "LONG_TEXT", "LOGIN"), undefined);
          } else {
            let adminMode = this.translateText.transform('SW_ADMINMODE', gipDefault, 'GIP_NAME', 'GIP_VALUE').toLowerCase() == "true" ? true : false;
            let jwtHelper = new JwtHelperService();
            let role = jwtHelper.decodeToken(result.access_token).role;
            if(adminMode){
              if(role == AuthenticationRole.InternalAdmin || role == AuthenticationRole.InternalUser){
                localStorage.setItem("access_token", result.access_token);
                localStorage.setItem("refresh_token", result.refresh_token);
                this.setUser()
                if (redirectUrl)
                  this.router.navigate([redirectUrl]);
              }
              else {
                this.shareData.currentResourceDefinition.subscribe(textData =>{
                  this.errorHandlingService.showError(this.translateResourceDefinition.transform('AM_MSG', textData, "KEY_NAME", "LONG_TEXT", "Common"), 'Error');
                })
              }
            } else {
              localStorage.setItem("access_token", result.access_token);
              localStorage.setItem("refresh_token", result.refresh_token);
              this.setUser()
              if (redirectUrl)
                this.router.navigate([redirectUrl]);
            }
          }
        });
      })
      .catch(err => {
        this.errorHandlingService.showError(this.translateResourceDefinition.transform("PortalTechnicalFail", resourceDefinition, "KEY_NAME", "LONG_TEXT", "LOGIN"), undefined);
      });
  }

  async setUser() {
    var resourceDefinition;
    var Picklist
    this.shareData.currentResourceDefinition.subscribe(data => resourceDefinition = data);
    this.shareData.currentPicklist.subscribe(data => Picklist = data);
    this.getToken().then(async token => {
      var currentUser = this.currentUser();
      if(currentUser){
        var urls = [
          `protocol/userinfo`,
          `admin/V_MS_USER_VL`
        ]
        const responses = await Promise.all(urls.map(url => fetch(this.commonService.getGipServicesUrl() + url, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        })));
    
        const results = new Array();
    
        for (const res of responses) {
          if(res.status === 401 && localStorage.getItem("access_token") != null){
            var getRefreshToken = await this.getRefreshToken();
            this.setUser();
          }
          const data = await res.json();
          results.push(data);
        }
        var user = results[0];
        if (user.VERIFIED == "0" || user.LOCKED == "1") {
          if(user.VERIFIED == '0'){
            this.errorHandlingService.showError(this.translateResourceDefinition.transform("currentUserNotVerified", resourceDefinition, "KEY_NAME", "LONG_TEXT", "LOGIN"), undefined);
          }
          if(user.LOCKED == '1'){
            this.errorHandlingService.showError(this.translateResourceDefinition.transform("currentUserLocked", resourceDefinition, "KEY_NAME", "LONG_TEXT", "LOGIN"), undefined);
          }
          this.logout();
        } else {
          this.shareData.changeUser(user);
        }
        
        var UserPicklist = results[1].value;
        var V_MS_USER_VL = [];
        UserPicklist.forEach(element => {
          let object = {
            key: element.VID,
            text : `${element.FIRST_NAME} ${element.NAME}`,
          }
          V_MS_USER_VL.push(object);
        });
        Picklist.V_MS_USER_VL = V_MS_USER_VL;
      }
    })

  }

  isLoggedIn() {
    if (localStorage.getItem('access_token')){
      return true;
    }
    return false;
  }

  currentUser() {
    const token = localStorage.getItem('access_token');
    if(token == undefined || token == "undefined"){
      this.logout();
    }
    if (token) {
      var login = globalConfig['Login'];
      var role = globalConfig['Role'];
      let jwtHelper = new JwtHelperService();
      const decodeToken = jwtHelper.decodeToken(token)
      const newToken = {
        USERGUID: decodeToken.jti,
        ROLE: decodeToken[role],
        LOGIN: decodeToken[login],
      }
      return newToken;
    }
    return null;
  }

  logout() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    this.shareData.changeUser(null);
  }

  async getToken() {
    if (localStorage.getItem('access_token')) {
      var accessToken = localStorage.getItem('access_token');
      let jwtHelper = new JwtHelperService();
      const decodeAccessToken = jwtHelper.decodeToken(accessToken);
      if (decodeAccessToken.exp > new Date().getTime() / 1000) {
        return localStorage.getItem('access_token');
      } else {
        if(this.waitForRefreshToken){
          return localStorage.getItem('access_token');
        } else {
          return await this.getRefreshToken();
        }
      }
    } else if(!this.waitForRefreshToken) {
      this.logout();
      return null;
    }
  }
  
  async getRefreshToken(){
    var refreshToken = localStorage.getItem('refresh_token');
    this.waitForRefreshToken = true;
    let requestBody = new URLSearchParams();
    requestBody.set('username', this.currentUser().LOGIN);
    requestBody.set('refresh_token', refreshToken);
    requestBody.set('grant_type', 'refresh_token');

    var url = globalConfig['AuthentificationConfig'];

    var authorization = globalConfig['Authorization'];
    const origin = window.location.origin;
    try {
      const response = await fetch(`${url}protocol/openid-connect/token`, {
        method: 'POST', body: requestBody, headers: {
          "Authorization": `Basic ${btoa(authorization)}`,
          "Content-Type": "application/x-www-form-urlencoded",
          "Host": url,
          "Origin" : origin,
        },
      })
      if(response.status == 400){
        this.logout();
        return null;
      }

      const result = await response.json();
      localStorage.setItem("access_token", result.access_token);
      localStorage.setItem("refresh_token", result.refresh_token);
      this.waitForRefreshToken = false;
      return result.access_token;
    }
    catch(e) {
        this.waitForRefreshToken = false;
        this.logout();
        return null;
    }
  }
}

export enum AuthenticationRole {
  InternalAdmin = "IN_ADM",
  InternalUser = "IN_USR",
  ExternalAdmin = "EX_ADM",
  ExternalUser = "EX_USR",
  Public = "PUBLIC"
}
